export const PALETTE = [
  { name: "Lavanda", bg: "#ECEEFE", soft: "#F6F7FF", border: "#D3D8FB", accent: "#6366F1", ink: "#312E81" },
  { name: "Menta", bg: "#E3F6EC", soft: "#F2FBF6", border: "#BCE8D2", accent: "#10B981", ink: "#065F46" },
  { name: "Albicocca", bg: "#FFF1DB", soft: "#FFF9EE", border: "#FBDDA8", accent: "#F59E0B", ink: "#78350F" },
  { name: "Cipria", bg: "#FDE7EC", soft: "#FFF4F6", border: "#F8C5D0", accent: "#F43F5E", ink: "#881337" },
  { name: "Cielo", bg: "#E2F2FC", soft: "#F2F9FE", border: "#B9DFF6", accent: "#0EA5E9", ink: "#0C4A6E" },
  { name: "Glicine", bg: "#EFE9FE", soft: "#F8F5FF", border: "#D8CBFB", accent: "#8B5CF6", ink: "#4C1D95" },
  { name: "Salvia", bg: "#E0F4F0", soft: "#F1FAF8", border: "#B3E3DA", accent: "#14B8A6", ink: "#134E4A" },
  { name: "Pesca", bg: "#FFEADF", soft: "#FFF6F1", border: "#FCCDB3", accent: "#F97316", ink: "#7C2D12" },
];

export const colorOf = (emp) => PALETTE[(emp?.color ?? 0) % PALETTE.length];

export const PRIORITIES = {
  bassa: { label: "Bassa", color: "#94A3B8" },
  media: { label: "Media", color: "#38BDF8" },
  alta: { label: "Alta", color: "#F59E0B" },
  urgente: { label: "Urgente", color: "#F43F5E" },
};
